<template>
  <b-navbar class="top-navbar" type="light" variant="light">
    <b-navbar-nav>
      <b-nav-text class="title-navbar"> {{ $t("navbar.centrosEfectivo") }}</b-nav-text>
    </b-navbar-nav>
  </b-navbar>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "top-navbar",
})
export default class TopNavbar extends Vue {
  constructor() {
    super();
  }
}
</script>

<style lang="scss" scoped>
.top-navbar {
  padding-left: 39px;
  height: 64px;
  background-color: #fafafa;
}

.title-navbar {
  font-size: 18px;
  font-weight: bold;
  color: var(--secundario-prosegur-oscuro);
  padding: 14px 0;
}

.signout {
  font-size: 16px;
  margin: 0;
  color: var(--secundario-prosegur-oscuro);
}

#logged-user {
  padding: 0 2em;
  margin-right: 1em;
  border-right: 1px solid;
  color: var(--secundario-prosegur-oscuro);

  .logged-user-icon {
    font-size: 24px;
    margin: auto 0.5em;
  }

  .fullname {
    font-weight: 500;
  }
}
</style>
